import { render, staticRenderFns } from "./RecentOrders.vue?vue&type=template&id=2a58e91e"
import script from "./RecentOrders.vue?vue&type=script&lang=js"
export * from "./RecentOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports